import NewDailyProduct from './NewDailyProduct'

export default NewDailyProduct



// WEBPACK FOOTER //
// ./src/components/DailyProducts/New/index.js